import {
  bbl as baseBbl,
  FeatureToggle as BaseFeatureToggle,
} from './baseApi/bbl'
import type { OverrideResults } from './overrideResult'

export type * from './baseApi/bbl'

export enum FeatureToggleEnum {
  invoiceStep1 = 'Leverandoerfaktura-steg-1',
  invoiceStep2 = 'Leverandoerfaktura-steg-2',
  prosjektarkiv = 'ProsjektArkivToggle',
  skjulKontaktpersoner = 'SkjulKontaktpersonerToggle',
  visProfilBildeForKontaktpersoner = 'VisProfilbildeKontaktpersonerToggle',
  allowEditElectronicCommunicationReservation = 'AllowEditElectronicCommunicationReservation',
  maalereMaxMaalerstand = 'MaalereMaxMaalerstandToggle',
  godtgjorelserMigrated = 'GodtgjorelserMigrated',
}

export type FeatureToggle = Omit<BaseFeatureToggle, 'id'> & {
  id: FeatureToggleEnum
}

export interface BBLApplications {
  name: PortalTypesEnum
}

export enum PortalTypesEnum {
  Forkjop = 'Forkjøp',
  Portal = 'Portalen',
  MinSide = 'Min side',
}

export const bblApi = baseBbl.enhanceEndpoints<
  never,
  OverrideResults<
    typeof baseBbl,
    {
      getBblFeaturetoggles: FeatureToggle[]
      getBblApplications: BBLApplications[]
    }
  >
>({
  endpoints: {},
})

export const {
  useGetBblQuery,
  useLazyGetBblQuery,
  useGetBblSummaryQuery,
  useGetBblSettingsQuery,
  useGetBblSettingsBblidQuery,
  useGetBblApplicationsQuery,
  useGetAllQuery,
  useGetBblFeaturetogglesQuery,
} = bblApi
